import AppConstants from 'general/constants/AppConstants';
import AppRoute from 'general/constants/AppRoute';
import Utils from 'general/utils/Utils';
import { t } from 'i18next';

function getMenuItemsList(user, poaUserId, agencyRoleList) {
  const MenuItemsList = {
    admin: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.dashboard,
        breadcrumPath: t('dashboard'),
      },
      {
        type: 'section',
        text: Number(poaUserId) !== user?.userId ? t('manageConfigDevice') : t('Quản lý trạm sạc'),
        path: AppRoute.manageChargeStations,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageChargeStation')),
        icon: 'fas fa-charging-station',
        path: AppRoute.manageChargeStations,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('chargeStationList')),
            path: AppRoute.stationList,
            breadcrumPath: t('chargeStationList'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('chargePointList')),
            path: AppRoute.pointList,
            breadcrumPath: t('chargePointList'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
            path: AppRoute.stationsMap,
            breadcrumPath: t('chargeStationMap'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Danh sách hóa đơn tiền điện')),
            path: AppRoute.energyBillList,
            breadcrumPath: t('Danh sách hóa đơn tiền điện'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Hãng sản xuất trụ sạc')),
            path: AppRoute.manageChargeBrand,
            breadcrumPath: t('Hãng sản xuất trụ sạc'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationList')),
        icon: 'fa-solid fa-charging-station',
        path: AppRoute.stationList,
        breadcrumPath: t('chargeStationList'),
        show: Number(poaUserId) === user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
        icon: 'fa-solid fa-map',
        path: AppRoute.stationsMap,
        breadcrumPath: t('chargeStationMap'),
        show: Number(poaUserId) === user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Quản lý trang thiết bị & dịch vụ')),
        icon: 'fa-solid fa-microchip',
        path: AppRoute.inventoryList,
        breadcrumPath: t('Quản lý trang thiết bị & dịch vụ'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageValuation')),
        icon: 'fa-solid fa-money-check-dollar-pen',
        path: AppRoute.valuationList,
        breadcrumPath: t('manageValuation'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageVehicles')),
        icon: 'fas fa-car-side-bolt',
        path: AppRoute.manageVehicles,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('vehicleList')),
            path: AppRoute.vehicleList,
            breadcrumPath: t('vehicleList'),
          },
          {
            text: t('Quản Lý Thẻ RFID'),
            path: AppRoute.rfidList,
            breadcrumPath: t('Quản Lý Thẻ RFID'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('manageVehicleBrand')),
            path: AppRoute.manageVehicleBrand,
            breadcrumPath: t('manageVehicleBrand'),
          },
        ],
      },
      // {
      //   type: 'item',
      //   text: Utils.capitalizeFirstLetter(t('Bảo trì')),
      //   icon: 'fas fa-bell-exclamation',
      //   path: AppRoute.chargeMaintain,
      //   breadcrumPath: t('Bảo trì'),
      //   show: Number(poaUserId) !== user?.userId,
      // },
      // {
      //   type: 'item',
      //   text: Utils.capitalizeFirstLetter(t('Lắp đặt')),
      //   icon: 'fas fa-wrench',
      //   path: AppRoute.chargeInstallation,
      //   breadcrumPath: t('Lắp đặt'),
      //   show: Number(poaUserId) !== user?.userId,
      // },
      {
        type: 'section',
        text: t('ManageChargeTransaction'),
        path: AppRoute.chargeTransactionList,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeTransactionList')),
        icon: 'fas fa-list',
        path: AppRoute.chargeTransactionList,
        breadcrumPath: t('chargeTransactionList'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: t('manageCustomer'),
        path: AppRoute.customerList,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('customerList')),
        icon: 'fa-solid fa-users',
        path: AppRoute.customerList,
        breadcrumPath: t('customerList'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: t('Giao Dịch KH/Đối Tác Nạp Tiền'),
        icon: 'fa-solid fa-circle-arrow-down-left',
        path: AppRoute.customerTopUpHistory,
        breadcrumPath: t('Giao Dịch KH/Đối Tác Nạp Tiền'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: t('manageDealership'),
        path: AppRoute.manageDealership,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dealershipList')),
        icon: 'fa-solid fa-briefcase',
        path: AppRoute.saleList,
        breadcrumPath: t('dealershipList'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dealerReconciliationReport')),
        icon: 'fa-solid fa-file-chart-column',
        path: AppRoute.saleReport,
        breadcrumPath: t('dealerReconciliationReport'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhóm quyền đại lý')),
        icon: 'fa-solid fa-user-gear',
        path: AppRoute.salePermissionList,
        breadcrumPath: t('Nhóm quyền đại lý'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: t('Quản lý NĐT và chủ mặt bằng'),
        path: AppRoute.managePartners,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: t('Nhà Đầu Tư HTKD'),
        icon: 'fa-solid fa-chart-user',
        path: AppRoute.groupsList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh Sách Nhà Đầu Tư HTKD'),
            path: AppRoute.groupList,
            breadcrumPath: t('Danh Sách Nhà Đầu Tư HTKD'),
          },
          {
            text: t('Danh Sách Gói Đầu Tư HTKD'),
            path: AppRoute.investmentPackList,
            breadcrumPath: t('Danh Sách Gói Đầu Tư HTKD'),
          },
          {
            text: t('Báo Cáo Đối Soát NĐT HTKD'),
            path: AppRoute.groupReport,
            breadcrumPath: t('Báo Cáo Đối Soát NĐT HTKD'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư nhượng quyền')),
        icon: 'fa-solid fa-user-tie',
        path: AppRoute.investorsList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh Sách NĐT NQ'),
            path: AppRoute.investorList,
            breadcrumPath: t('Danh Sách NĐT NQ'),
          },
          {
            text: t('Báo Cáo Đối Soát NĐT NQ'),
            path: AppRoute.investorReport,
            breadcrumPath: t('Báo Cáo Đối Soát NĐT NQ'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư liên kết')),
        icon: 'fa-solid fa-chart-network',
        path: AppRoute.coinvestorsList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh Sách NĐT Liên Kết'),
            path: AppRoute.coinvestorList,
            breadcrumPath: t('Danh sách NĐT liên kết'),
          },
          {
            text: t('Báo Cáo Đối Soát NĐT Liên Kết'),
            path: AppRoute.coinvestorReport,
            breadcrumPath: t('Báo cáo đối soát NĐT liên kết'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('landowner')),
        icon: 'fa-solid fa-house-user',
        path: AppRoute.landlordsList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('landownerList')),
            path: AppRoute.landlordList,
            breadcrumPath: t('landownerList'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Danh sách mặt bằng')),
            path: AppRoute.premisesList,
            breadcrumPath: t('Danh sách mặt bằng'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('landownerReconciliationReport')),
            path: AppRoute.landlordReport,
            breadcrumPath: t('landownerReconciliationReport'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đối tác mua trụ sạc')),
        icon: 'fa-solid fa-user-tie-hair',
        path: AppRoute.chargePointPartnersList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('Danh sách đối tác mua trụ sạc')),
            path: AppRoute.chargePointPartnerList,
            breadcrumPath: t('Danh sách đối tác mua trụ sạc'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Doanh nghiệp vận tải')),
        icon: 'fa-solid fa-steering-wheel',
        path: AppRoute.manageFleet,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh Sách DNVT'),
            path: AppRoute.fleetList,
            breadcrumPath: t('Danh sách DNVT'),
          },
          {
            text: t('Báo Cáo Đối Soát DNVT'),
            path: AppRoute.fleetReport,
            breadcrumPath: t('Báo cáo đối soát DNVT'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đối tác mua voucher')),
        icon: 'fa-solid fa-gift-card',
        path: AppRoute.manageVoucherPartner,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh sách đối tác'),
            path: AppRoute.voucherPartnerList,
            breadcrumPath: t('Danh sách đối tác'),
          },
          {
            text: t('Danh sách lô voucher'),
            path: AppRoute.voucherBatchList,
            breadcrumPath: t('Danh sách lô voucher'),
          },
          {
            text: t('Danh sách voucher'),
            path: AppRoute.voucherList,
            breadcrumPath: t('Danh sách voucher'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhóm quyền đối tác')),
        icon: 'fa-solid fa-user-gear',
        path: AppRoute.partnerPermissionList,
        breadcrumPath: t('Nhóm quyền đối tác'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: 'BẢO TRÌ, SỬA CHỮA',
        path: AppRoute.maintainerList,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter('Danh sách kỹ thuật viên'),
        icon: 'fas fa-user-helmet-safety',
        path: AppRoute.maintainerList,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter('Danh sách công việc'),
        icon: 'fas fa-screwdriver-wrench',
        path: AppRoute.ticketList,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter('Báo cáo đối soát kỹ thuật viên'),
        icon: 'fas fa-file-chart-column',
        path: AppRoute.maintainerReport,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: t('system'),
        path: AppRoute.manageSystem,
      },
      {
        type: 'item',
        text: t('Danh Sách Hợp Đồng'),
        icon: 'fas fa-file-contract',
        path: AppRoute.poaContract,
        breadcrumPath: t('Danh Sách Hợp Đồng'),
        show: Number(poaUserId) === user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageOrder')),
        icon: 'fas fa-box-circle-check',
        path: AppRoute.orderList,
        breadcrumPath: t('manageOrder'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Danh sách hợp đồng')),
        icon: 'fas fa-file-contract',
        path: AppRoute.contractList,
        breadcrumPath: t('Danh sách hợp đồng'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử giao dịch đối tác')),
        icon: 'fa-solid fa-circle-dollar',
        path: AppRoute.managePaymentTransactions,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('Chi trả hoa hồng & doanh thu')),
            path: AppRoute.commissionTransactionList,
            breadcrumPath: t('Chi trả hoa hồng & doanh thu'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Yêu cầu rút tiền của đối tác')),
            path: AppRoute.withdrawTransactionList,
            breadcrumPath: t('Yêu cầu rút tiền của đối tác'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Cấu hình hoa hồng bán hàng')),
        icon: 'fa-solid fa-trillium',
        path: AppRoute.agencyConfigCommission,
        breadcrumPath: t('Cấu hình hoa hồng bán hàng'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageStaffs')),
        icon: 'fa-solid fa-user-vneck',
        path: AppRoute.manageStaffs,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('staffList')),
            path: AppRoute.staffList,
            breadcrumPath: t('staffList'),
          },
          {
            text: t('Quản Lý Nhóm Quyền NV'),
            path: AppRoute.staffPermissionList,
            breadcrumPath: t('Quản Lý Nhóm Quyền NV'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Thiết lập chung')),
        icon: 'fa-solid fa-gear',
        path: AppRoute.setting,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('Cấu hình thông báo gửi')),
            path: AppRoute.pushNotificationList,
            breadcrumPath: t('Cấu hình thông báo gửi'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Thông báo hệ thống')),
            path: AppRoute.systemLogList,
            breadcrumPath: t('Thông báo hệ thống'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Nhật ký hoạt động')),
            path: AppRoute.actionLogList,
            breadcrumPath: t('Nhật ký hoạt động'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Cấu hình hướng dẫn sử dụng')),
            path: AppRoute.tutorialList,
            breadcrumPath: t('Cấu hình hướng dẫn sử dụng'),
          },
          // {
          //   text: Utils.capitalizeFirstLetter(t('Gói bảo hiểm')),
          //   path: AppRoute.insurancePackList,
          //   breadcrumPath: t('Gói bảo hiểm'),
          // },
          // {
          //   text: Utils.capitalizeFirstLetter(t('Chương trình khuyến mãi')),
          //   path: AppRoute.voucherList,
          //   breadcrumPath: t('Chương trình khuyến mãi'),
          // },
          {
            text: Utils.capitalizeFirstLetter(t('Cài đặt chung')),
            path: AppRoute.generalSetting,
            breadcrumPath: t('Cài đặt chung'),
          },
        ],
      },
    ],
    operator: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.dashboard,
        breadcrumPath: t('dashboard'),
      },
      {
        type: 'section',
        text: Number(poaUserId) !== user?.userId ? t('manageConfigDevice') : t('Quản lý trạm sạc'),
        path: AppRoute.manageChargeStations,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageChargeStation')),
        icon: 'fas fa-charging-station',
        path: AppRoute.manageChargeStations,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('chargeStationList')),
            path: AppRoute.stationList,
            breadcrumPath: t('chargeStationList'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('chargePointList')),
            path: AppRoute.pointList,
            breadcrumPath: t('chargePointList'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
            path: AppRoute.stationsMap,
            breadcrumPath: t('chargeStationMap'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Danh sách hóa đơn tiền điện')),
            path: AppRoute.energyBillList,
            breadcrumPath: t('Danh sách hóa đơn tiền điện'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Hãng sản xuất trụ sạc')),
            path: AppRoute.manageChargeBrand,
            breadcrumPath: t('Hãng sản xuất trụ sạc'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationList')),
        icon: 'fa-solid fa-charging-station',
        path: AppRoute.stationList,
        breadcrumPath: t('chargeStationList'),
        show: Number(poaUserId) === user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
        icon: 'fa-solid fa-map',
        path: AppRoute.stationsMap,
        breadcrumPath: t('chargeStationMap'),
        show: Number(poaUserId) === user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Quản lý trang thiết bị & dịch vụ')),
        icon: 'fa-solid fa-microchip',
        path: AppRoute.inventoryList,
        breadcrumPath: t('Quản lý trang thiết bị & dịch vụ'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageValuation')),
        icon: 'fa-solid fa-money-check-dollar-pen',
        path: AppRoute.valuationList,
        breadcrumPath: t('manageValuation'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageVehicles')),
        icon: 'fas fa-car-side-bolt',
        path: AppRoute.manageVehicles,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('vehicleList')),
            path: AppRoute.vehicleList,
            breadcrumPath: t('vehicleList'),
          },
          {
            text: t('Quản Lý Thẻ RFID'),
            path: AppRoute.rfidList,
            breadcrumPath: t('Quản Lý Thẻ RFID'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('manageVehicleBrand')),
            path: AppRoute.manageVehicleBrand,
            breadcrumPath: t('manageVehicleBrand'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Bảo trì')),
        icon: 'fas fa-bell-exclamation',
        path: AppRoute.chargeMaintain,
        breadcrumPath: t('Bảo trì'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lắp đặt')),
        icon: 'fas fa-wrench',
        path: AppRoute.chargeInstallation,
        breadcrumPath: t('Lắp đặt'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: t('ManageChargeTransaction'),
        path: AppRoute.chargeTransactionList,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeTransactionList')),
        icon: 'fas fa-list',
        path: AppRoute.chargeTransactionList,
        breadcrumPath: t('chargeTransactionList'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: t('manageCustomer'),
        path: AppRoute.customerList,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('customerList')),
        icon: 'fa-solid fa-users',
        path: AppRoute.customerList,
        breadcrumPath: t('customerList'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: t('Giao Dịch KH/Đối Tác Nạp Tiền'),
        icon: 'fa-solid fa-circle-arrow-down-left',
        path: AppRoute.customerTopUpHistory,
        breadcrumPath: t('Giao Dịch KH/Đối Tác Nạp Tiền'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: t('manageDealership'),
        path: AppRoute.manageDealership,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dealershipList')),
        icon: 'fa-solid fa-briefcase',
        path: AppRoute.saleList,
        breadcrumPath: t('dealershipList'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dealerReconciliationReport')),
        icon: 'fa-solid fa-file-chart-column',
        path: AppRoute.saleReport,
        breadcrumPath: t('dealerReconciliationReport'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhóm quyền đại lý')),
        icon: 'fa-solid fa-user-gear',
        path: AppRoute.salePermissionList,
        breadcrumPath: t('Nhóm quyền đại lý'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: t('Quản lý NĐT và chủ mặt bằng'),
        path: AppRoute.managePartners,
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: t('Nhà Đầu Tư HTKD'),
        icon: 'fa-solid fa-chart-user',
        path: AppRoute.groupsList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh Sách Nhà Đầu Tư HTKD'),
            path: AppRoute.groupList,
            breadcrumPath: t('Danh Sách Nhà Đầu Tư HTKD'),
          },
          {
            text: t('Danh Sách Gói Đầu Tư HTKD'),
            path: AppRoute.investmentPackList,
            breadcrumPath: t('Danh Sách Gói Đầu Tư HTKD'),
          },
          {
            text: t('Báo Cáo Đối Soát NĐT HTKD'),
            path: AppRoute.groupReport,
            breadcrumPath: t('Báo Cáo Đối Soát NĐT HTKD'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư nhượng quyền')),
        icon: 'fa-solid fa-user-tie',
        path: AppRoute.investorsList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh Sách NĐT NQ'),
            path: AppRoute.investorList,
            breadcrumPath: t('Danh Sách NĐT NQ'),
          },
          {
            text: t('Báo Cáo Đối Soát NĐT NQ'),
            path: AppRoute.investorReport,
            breadcrumPath: t('Báo Cáo Đối Soát NĐT NQ'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư liên kết')),
        icon: 'fa-solid fa-chart-network',
        path: AppRoute.coinvestorsList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh Sách NĐT Liên Kết'),
            path: AppRoute.coinvestorList,
            breadcrumPath: t('Danh sách NĐT liên kết'),
          },
          {
            text: t('Báo Cáo Đối Soát NĐT Liên Kết'),
            path: AppRoute.coinvestorReport,
            breadcrumPath: t('Báo cáo đối soát NĐT liên kết'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('landowner')),
        icon: 'fa-solid fa-house-user',
        path: AppRoute.landlordsList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('landownerList')),
            path: AppRoute.landlordList,
            breadcrumPath: t('landownerList'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Danh sách mặt bằng')),
            path: AppRoute.premisesList,
            breadcrumPath: t('Danh sách mặt bằng'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('landownerReconciliationReport')),
            path: AppRoute.landlordReport,
            breadcrumPath: t('landownerReconciliationReport'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đối tác mua trụ sạc')),
        icon: 'fa-solid fa-user-tie-hair',
        path: AppRoute.chargePointPartnersList,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('Danh sách đối tác mua trụ sạc')),
            path: AppRoute.chargePointPartnerList,
            breadcrumPath: t('Danh sách đối tác mua trụ sạc'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Doanh nghiệp vận tải')),
        icon: 'fa-solid fa-steering-wheel',
        path: AppRoute.manageFleet,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh Sách DNVT'),
            path: AppRoute.fleetList,
            breadcrumPath: t('Danh sách DNVT'),
          },
          {
            text: t('Báo Cáo Đối Soát DNVT'),
            path: AppRoute.fleetReport,
            breadcrumPath: t('Báo cáo đối soát DNVT'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đối tác mua voucher')),
        icon: 'fa-solid fa-gift-card',
        path: AppRoute.manageVoucherPartner,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: t('Danh sách đối tác'),
            path: AppRoute.voucherPartnerList,
            breadcrumPath: t('Danh sách đối tác'),
          },
          {
            text: t('Danh sách lô voucher'),
            path: AppRoute.voucherBatchList,
            breadcrumPath: t('Danh sách lô voucher'),
          },
          {
            text: t('Danh sách voucher'),
            path: AppRoute.voucherList,
            breadcrumPath: t('Danh sách voucher'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhóm quyền đối tác')),
        icon: 'fa-solid fa-user-gear',
        path: AppRoute.partnerPermissionList,
        breadcrumPath: t('Nhóm quyền đối tác'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'section',
        text: t('system'),
        path: AppRoute.manageSystem,
      },
      {
        type: 'item',
        text: t('Danh Sách Hợp Đồng'),
        icon: 'fas fa-file-contract',
        path: AppRoute.poaContract,
        breadcrumPath: t('Danh Sách Hợp Đồng'),
        show: Number(poaUserId) === user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageOrder')),
        icon: 'fas fa-box-circle-check',
        path: AppRoute.orderList,
        breadcrumPath: t('manageOrder'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Danh sách hợp đồng')),
        icon: 'fas fa-file-contract',
        path: AppRoute.contractList,
        breadcrumPath: t('Danh sách hợp đồng'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử giao dịch đối tác')),
        icon: 'fa-solid fa-circle-dollar',
        path: AppRoute.managePaymentTransactions,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('Chi trả hoa hồng & doanh thu')),
            path: AppRoute.commissionTransactionList,
            breadcrumPath: t('Chi trả hoa hồng & doanh thu'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Yêu cầu rút tiền của đối tác')),
            path: AppRoute.withdrawTransactionList,
            breadcrumPath: t('Yêu cầu rút tiền của đối tác'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Cấu hình hoa hồng bán hàng')),
        icon: 'fa-solid fa-trillium',
        path: AppRoute.agencyConfigCommission,
        breadcrumPath: t('Cấu hình hoa hồng bán hàng'),
        show: Number(poaUserId) !== user?.userId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageStaffs')),
        icon: 'fa-solid fa-user-vneck',
        path: AppRoute.manageStaffs,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('staffList')),
            path: AppRoute.staffList,
            breadcrumPath: t('staffList'),
          },
          {
            text: t('Quản Lý Nhóm Quyền NV'),
            path: AppRoute.staffPermissionList,
            breadcrumPath: t('Quản Lý Nhóm Quyền NV'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Thiết lập chung')),
        icon: 'fa-solid fa-gear',
        path: AppRoute.setting,
        show: Number(poaUserId) !== user?.userId,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('Cấu hình thông báo gửi')),
            path: AppRoute.pushNotificationList,
            breadcrumPath: t('Cấu hình thông báo gửi'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Thông báo hệ thống')),
            path: AppRoute.systemLogList,
            breadcrumPath: t('Thông báo hệ thống'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Nhật ký hoạt động')),
            path: AppRoute.actionLogList,
            breadcrumPath: t('Nhật ký hoạt động'),
          },
          // {
          //   text: Utils.capitalizeFirstLetter(t('Gói bảo hiểm')),
          //   path: AppRoute.insurancePackList,
          //   breadcrumPath: t('Gói bảo hiểm'),
          // },
          // {
          //   text: Utils.capitalizeFirstLetter(t('Chương trình khuyến mãi')),
          //   path: AppRoute.voucherList,
          //   breadcrumPath: t('Chương trình khuyến mãi'),
          // },
          {
            text: Utils.capitalizeFirstLetter(t('Cài đặt chung')),
            path: AppRoute.generalSetting,
            breadcrumPath: t('Cài đặt chung'),
          },
        ],
      },
    ],
    sale: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.dashboardList,
        breadcrumPath: t('dashboard'),
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('saleDashboard')),
            path: AppRoute.saleDashboard,
          },
          {
            text: Utils.capitalizeFirstLetter(t('Tổng quan vận hành')),
            path: AppRoute.dashboard,
            show: !user?.agency?.parentAgencyId,
          },
        ],
      },
      {
        type: 'section',
        text: t('manageDealership'),
        path: AppRoute.manageDealership,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(!user?.agency?.parentAgencyId ? t('Thông tin tổng đại lý') : t('Thông tin đại lý')),
        icon: 'fa-solid fa-briefcase',
        path: `${AppRoute.saleInfo}/${user?.agency?.agencyId}`,
        breadcrumPath: t('Thông tin đại lý'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đại lý cấp dưới')),
        icon: 'fa-solid fa-users',
        path: AppRoute.subSaleList,
        breadcrumPath: t('Danh sách đại lý cấp dưới'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageOrder')),
        icon: 'fas fa-box-circle-check',
        path: AppRoute.agencyOrderList,
        // subMenuItems: [
        //   {
        //     text: Utils.capitalizeFirstLetter(t('Đơn mua')),
        //     path: AppRoute.purchaseOrder,
        //     breadcrumPath: t('Đơn mua'),
        //   },
        //   {
        //     text: Utils.capitalizeFirstLetter(t('Đơn bán')),
        //     path: AppRoute.saleOrder,
        //     breadcrumPath: t('Đơn bán'),
        //   },
        // ],
        breadcrumPath: t('manageOrder'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Tạo đơn hàng')),
        icon: 'fa-solid fa-cart-plus',
        path: `${AppRoute.agencyAddOrder}`,
        breadcrumPath: t('Tạo đơn hàng'),
        show: true,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dealerReconciliationReport')),
        icon: 'fa-solid fa-file-chart-column',
        path: AppRoute.saleReport,
        breadcrumPath: t('dealerReconciliationReport'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Rút tiền về tài khoản')),
        icon: 'fa-solid fa-hand-holding-dollar',
        path: AppRoute.withdrawTransaction,
        breadcrumPath: t('Rút tiền về tài khoản'),
        show: !!user?.agency?.parentAgencyId,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử giao dịch')),
        icon: 'fa-solid fa-circle-dollar',
        path: AppRoute.transactionHistory,
        breadcrumPath: t('Lịch sử giao dịch'),
        show: !!user?.agency?.parentAgencyId,
      },
      {
        type: 'section',
        text: t('Quản lý NĐT và chủ mặt bằng'),
        path: AppRoute.managePartners,
      },
      {
        type: 'item',
        text: t('Nhà Đầu Tư HTKD'),
        icon: 'fa-solid fa-chart-user',
        path: AppRoute.groupList,
        breadcrumPath: t('Danh sách nhà đầu tư HTKD'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư nhượng quyền')),
        icon: 'fa-solid fa-user-tie',
        path: AppRoute.investorList,
        breadcrumPath: t('Danh sách nhà đầu tư nhượng quyền'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư liên kết')),
        icon: 'fa-solid fa-chart-network',
        path: AppRoute.coinvestorList,
        breadcrumPath: t('Nhà đầu tư liên kết'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('landowner')),
        icon: 'fa-solid fa-house-user',
        path: AppRoute.landlordList,
        breadcrumPath: t('landownerList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đối tác mua trụ sạc')),
        icon: 'fa-solid fa-user-tie-hair',
        path: AppRoute.chargePointPartnerList,
        breadcrumPath: t('Đối tác mua trụ sạc'),
      },
      {
        type: 'section',
        text: Utils.capitalizeFirstLetter(t('Quản lý trạm sạc')),
        path: AppRoute.manageChargeStations,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationList')),
        icon: 'fa-solid fa-charging-station',
        path: AppRoute.stationList,
        breadcrumPath: t('chargeStationList'),
        show: !user?.agency?.parentAgencyId,
      },
      // {
      //   type: 'item',
      //   text: Utils.capitalizeFirstLetter(t('chargePointList')),
      //   icon: 'fa-solid fa-transformer-bolt',
      //   path: AppRoute.pointList,
      //   breadcrumPath: t('chargePointList'),
      //   show: !user?.agency?.parentAgencyId,
      // },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
        icon: 'fa-solid fa-map',
        path: AppRoute.stationsMap,
        breadcrumPath: t('chargeStationMap'),
      },
      {
        type: 'section',
        text: t('system'),
        path: AppRoute.manageSystem,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageStaffs')),
        icon: 'fa-solid fa-user-vneck',
        path: AppRoute.manageStaffs,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('staffList')),
            path: AppRoute.staffList,
            breadcrumPath: t('staffList'),
          },
          {
            text: t('Quản Lý Nhóm Quyền NV'),
            path: AppRoute.staffPermissionList,
            breadcrumPath: t('Quản Lý Nhóm Quyền NV'),
          },
        ],
      },
    ],
    investor: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.dashboard,
        breadcrumPath: t('dashboard'),
        subMenuItems: [
          {
            text: 'Tổng Quan Đầu Tư NQ',
            path: AppRoute.investorDashboard,
          },
          {
            text: Utils.capitalizeFirstLetter(t('saleDashboard')),
            path: AppRoute.saleDashboard,
          },
        ],
      },
      {
        type: 'section',
        text: t('Nhà đầu tư nhượng quyền'),
        path: AppRoute.manageInvester,
      },
      {
        type: 'item',
        text: t('Thông Tin NĐT Nhượng Quyền'),
        icon: 'fa-solid fa-user-tie',
        path: `${AppRoute.investorInfo}/${user?.agency?.agencyId}`,
        breadcrumPath: t('Thông Tin NĐT Nhượng Quyền'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đơn Hàng Của Tôi')),
        icon: 'fa-solid fa-cart-plus',
        path: AppRoute.purchaseOrder,
        breadcrumPath: t('Đơn Hàng Của Tôi'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đơn Hàng Nhà Đầu Tư')),
        icon: 'fas fa-store',
        path: AppRoute.saleOrder,
        breadcrumPath: t('Đơn Hàng Nhà Đầu Tư'),
      },
      {
        type: 'item',
        text: t('Báo Cáo Đối Soát NĐT NQ'),
        icon: 'fa-solid fa-file-chart-column',
        path: AppRoute.investorReport,
        breadcrumPath: t('Báo Cáo Đối Soát NĐT NQ'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Rút tiền về tài khoản')),
        icon: 'fa-solid fa-hand-holding-dollar',
        path: AppRoute.withdrawTransaction,
        breadcrumPath: t('Rút tiền về tài khoản'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử giao dịch')),
        icon: 'fa-solid fa-circle-dollar',
        path: AppRoute.transactionHistory,
        breadcrumPath: t('Lịch sử giao dịch'),
      },
      {
        type: 'section',
        text: t('Quản lý trạm sạc'),
        path: AppRoute.manageChargeStations,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationList')),
        icon: 'fa-solid fa-charging-station',
        path: AppRoute.stationList,
        breadcrumPath: t('chargeStationList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargePointList')),
        icon: 'fa-solid fa-transformer-bolt',
        path: AppRoute.pointList,
        breadcrumPath: t('chargePointList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
        icon: 'fa-solid fa-map',
        path: AppRoute.stationsMap,
        breadcrumPath: t('chargeStationMap'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Danh sách hóa đơn tiền điện')),
        icon: 'fa-solid fa-file-invoice-dollar',
        path: AppRoute.energyBillList,
        breadcrumPath: t('Danh sách hóa đơn tiền điện'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Bảo trì/sửa chữa')),
        icon: 'fa-solid fa-screwdriver-wrench',
        path: AppRoute.ticketList,
        breadcrumPath: t('Bảo trì/sửa chữa'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageValuation')),
        icon: 'fa-solid fa-money-check-dollar-pen',
        path: AppRoute.valuationList,
        breadcrumPath: t('manageValuation'),
      },
      {
        type: 'section',
        text: t('ManageChargeTransaction'),
        path: AppRoute.chargeTransactionList,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeTransactionList')),
        icon: 'fas fa-list',
        path: AppRoute.chargeTransactionList,
        breadcrumPath: t('chargeTransactionList'),
      },
      {
        type: 'section',
        text: t('Quản lý NĐT và chủ mặt bằng'),
        path: AppRoute.managePartners,
      },
      {
        type: 'item',
        text: t('Nhà Đầu Tư HTKD'),
        icon: 'fa-solid fa-chart-user',
        path: AppRoute.groupList,
        breadcrumPath: t('Danh sách nhà đầu tư HTKD'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư nhượng quyền')),
        icon: 'fa-solid fa-user-tie',
        path: AppRoute.investorList,
        breadcrumPath: t('Danh sách nhà đầu tư nhượng quyền'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư liên kết')),
        icon: 'fa-solid fa-chart-network',
        path: AppRoute.coinvestorList,
        breadcrumPath: t('Nhà đầu tư liên kết'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('landowner')),
        icon: 'fa-solid fa-house-user',
        path: AppRoute.landlordList,
        breadcrumPath: t('landownerList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đối tác mua trụ sạc')),
        icon: 'fa-solid fa-user-tie-hair',
        path: AppRoute.chargePointPartnerList,
        breadcrumPath: t('Đối tác mua trụ sạc'),
      },
      {
        type: 'section',
        text: t('system'),
        path: AppRoute.manageSystem,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageStaffs')),
        icon: 'fa-solid fa-user-vneck',
        path: AppRoute.manageStaffs,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('staffList')),
            path: AppRoute.staffList,
            breadcrumPath: t('staffList'),
          },
          {
            text: t('Quản Lý Nhóm Quyền NV'),
            path: AppRoute.staffPermissionList,
            breadcrumPath: t('Quản Lý Nhóm Quyền NV'),
          },
        ],
      },
    ],
    coinvestor: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.dashboard,
        breadcrumPath: t('dashboard'),
        subMenuItems: [
          {
            text: 'Tổng Quan Đầu Tư',
            path: AppRoute.coinvestorDashboard,
          },
          {
            text: Utils.capitalizeFirstLetter(t('saleDashboard')),
            path: AppRoute.saleDashboard,
          },
        ],
      },
      {
        type: 'section',
        text: t('NHÀ ĐẦU TƯ LIÊN KẾT'),
        path: AppRoute.manageInvester,
      },
      {
        type: 'item',
        text: t('Thông Tin NĐT liên kết'),
        icon: 'fa-solid fa-user-tie',
        path: `${AppRoute.coinvestorInfo}/${user?.agency?.agencyId}`,
        breadcrumPath: t('Thông Tin NĐT liên kết'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đơn Hàng Của Tôi')),
        icon: 'fa-solid fa-cart-plus',
        path: AppRoute.purchaseOrder,
        breadcrumPath: t('Đơn Hàng Của Tôi'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đơn Hàng Nhà Đầu Tư')),
        icon: 'fas fa-store',
        path: AppRoute.saleOrder,
        breadcrumPath: t('Đơn Hàng Nhà Đầu Tư'),
      },
      {
        type: 'item',
        text: t('Báo Cáo Đối Soát NĐT Liên Kết'),
        icon: 'fa-solid fa-file-chart-column',
        path: AppRoute.investorReport,
        breadcrumPath: t('Báo cáo đối soát NĐT liên kết'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Rút tiền về tài khoản')),
        icon: 'fa-solid fa-hand-holding-dollar',
        path: AppRoute.withdrawTransaction,
        breadcrumPath: t('Rút tiền về tài khoản'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử giao dịch')),
        icon: 'fa-solid fa-circle-dollar',
        path: AppRoute.transactionHistory,
        breadcrumPath: t('Lịch sử giao dịch'),
      },
      {
        type: 'section',
        text: t('Quản lý trạm sạc'),
        path: AppRoute.manageChargeStations,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationList')),
        icon: 'fa-solid fa-charging-station',
        path: AppRoute.stationList,
        breadcrumPath: t('chargeStationList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargePointList')),
        icon: 'fa-solid fa-transformer-bolt',
        path: AppRoute.pointList,
        breadcrumPath: t('chargePointList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
        icon: 'fa-solid fa-map',
        path: AppRoute.stationsMap,
        breadcrumPath: t('chargeStationMap'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Danh sách hóa đơn tiền điện')),
        icon: 'fa-solid fa-file-invoice-dollar',
        path: AppRoute.energyBillList,
        breadcrumPath: t('Danh sách hóa đơn tiền điện'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Bảo trì/sửa chữa')),
        icon: 'fa-solid fa-screwdriver-wrench',
        path: AppRoute.ticketList,
        breadcrumPath: t('Bảo trì/sửa chữa'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageValuation')),
        icon: 'fa-solid fa-money-check-dollar-pen',
        path: AppRoute.valuationList,
        breadcrumPath: t('manageValuation'),
      },
      {
        type: 'section',
        text: t('ManageChargeTransaction'),
        path: AppRoute.chargeTransactionList,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeTransactionList')),
        icon: 'fas fa-list',
        path: AppRoute.chargeTransactionList,
        breadcrumPath: t('chargeTransactionList'),
      },
      {
        type: 'section',
        text: t('Quản lý NĐT và chủ mặt bằng'),
        path: AppRoute.managePartners,
      },
      {
        type: 'item',
        text: t('Nhà Đầu Tư HTKD'),
        icon: 'fa-solid fa-chart-user',
        path: AppRoute.groupList,
        breadcrumPath: t('Danh sách nhà đầu tư HTKD'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư nhượng quyền')),
        icon: 'fa-solid fa-user-tie',
        path: AppRoute.investorList,
        breadcrumPath: t('Danh sách nhà đầu tư nhượng quyền'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư liên kết')),
        icon: 'fa-solid fa-chart-network',
        path: AppRoute.coinvestorList,
        breadcrumPath: t('Nhà đầu tư liên kết'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('landowner')),
        icon: 'fa-solid fa-house-user',
        path: AppRoute.landlordList,
        breadcrumPath: t('landownerList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đối tác mua trụ sạc')),
        icon: 'fa-solid fa-user-tie-hair',
        path: AppRoute.chargePointPartnerList,
        breadcrumPath: t('Đối tác mua trụ sạc'),
      },
      {
        type: 'section',
        text: t('system'),
        path: AppRoute.manageSystem,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageStaffs')),
        icon: 'fa-solid fa-user-vneck',
        path: AppRoute.manageStaffs,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('staffList')),
            path: AppRoute.staffList,
            breadcrumPath: t('staffList'),
          },
          {
            text: t('Quản Lý Nhóm Quyền NV'),
            path: AppRoute.staffPermissionList,
            breadcrumPath: t('Quản Lý Nhóm Quyền NV'),
          },
        ],
      },
    ],
    group: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.dashboard,
        breadcrumPath: t('dashboard'),
        subMenuItems: [
          {
            text: 'Tổng Quan Đầu Tư HTKD',
            path: AppRoute.groupDashboard,
          },
          {
            text: Utils.capitalizeFirstLetter(t('saleDashboard')),
            path: AppRoute.saleDashboard,
          },
        ],
      },
      {
        type: 'section',
        text: t('Nhà đầu tư hợp tác kinh doanh'),
        path: AppRoute.manageInvestorGroupSection,
      },
      {
        type: 'item',
        text: t('Thông Tin Nhà Đầu Tư HTKD'),
        icon: 'fa-solid fa-user-tie',
        path: `${AppRoute.groupInfo}/${user?.agency?.agencyId}`,
        breadcrumPath: t('Thông Tin Nhà Đầu Tư HTKD'),
      },
      {
        type: 'item',
        text: t('Đơn Hàng Của Tôi'),
        icon: 'fa-solid fa-box-check',
        path: AppRoute.purchaseOrder,
        breadcrumPath: t('Đơn Hàng Của Tôi'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đơn Hàng Nhà Đầu Tư')),
        icon: 'fas fa-store',
        path: AppRoute.saleOrder,
        breadcrumPath: t('Đơn Hàng Nhà Đầu Tư'),
      },
      {
        type: 'item',
        text: t('Báo Cáo Đối Soát NĐT HTKD'),
        icon: 'fa-solid fa-file-chart-column',
        path: AppRoute.groupReport,
        breadcrumPath: t('Báo Cáo Đối Soát NĐT HTKD'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Rút tiền về tài khoản')),
        icon: 'fa-solid fa-hand-holding-dollar',
        path: AppRoute.withdrawTransaction,
        breadcrumPath: t('Rút tiền về tài khoản'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử giao dịch')),
        icon: 'fa-solid fa-circle-dollar',
        path: AppRoute.transactionHistory,
        breadcrumPath: t('Lịch sử giao dịch'),
      },
      {
        type: 'section',
        text: t('Quản lý trạm sạc'),
        path: AppRoute.manageChargeStations,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationList')),
        icon: 'fa-solid fa-charging-station',
        path: AppRoute.stationList,
        breadcrumPath: t('chargeStationList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
        icon: 'fa-solid fa-map',
        path: AppRoute.stationsMap,
        breadcrumPath: t('chargeStationMap'),
      },
      {
        type: 'section',
        text: t('ManageChargeTransaction'),
        path: AppRoute.chargeTransactionList,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeTransactionList')),
        icon: 'fas fa-list',
        path: AppRoute.chargeTransactionList,
        breadcrumPath: t('chargeTransactionList'),
      },
      {
        type: 'section',
        text: t('Quản lý NĐT và chủ mặt bằng'),
        path: AppRoute.managePartners,
      },
      {
        type: 'item',
        text: t('Nhà Đầu Tư HTKD'),
        icon: 'fa-solid fa-chart-user',
        path: AppRoute.groupList,
        breadcrumPath: t('Danh sách nhà đầu tư HTKD'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư nhượng quyền')),
        icon: 'fa-solid fa-user-tie',
        path: AppRoute.investorList,
        breadcrumPath: t('Danh sách nhà đầu tư nhượng quyền'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nhà đầu tư liên kết')),
        icon: 'fa-solid fa-chart-network',
        path: AppRoute.coinvestorList,
        breadcrumPath: t('Nhà đầu tư liên kết'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('landowner')),
        icon: 'fa-solid fa-house-user',
        path: AppRoute.landlordList,
        breadcrumPath: t('landownerList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Đối tác mua trụ sạc')),
        icon: 'fa-solid fa-user-tie-hair',
        path: AppRoute.chargePointPartnerList,
        breadcrumPath: t('Đối tác mua trụ sạc'),
      },
      {
        type: 'section',
        text: t('system'),
        path: AppRoute.manageSystem,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageStaffs')),
        icon: 'fa-solid fa-user-vneck',
        path: AppRoute.manageStaffs,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('staffList')),
            path: AppRoute.staffList,
            breadcrumPath: t('staffList'),
          },
          {
            text: t('Quản Lý Nhóm Quyền NV'),
            path: AppRoute.staffPermissionList,
            breadcrumPath: t('Quản Lý Nhóm Quyền NV'),
          },
        ],
      },
    ],
    landlord: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.dashboard,
        breadcrumPath: t('dashboard'),
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('landlordDashboard')),
            path: AppRoute.landlordDashboard,
          },
        ],
      },
      {
        type: 'section',
        text: t('manageLandowner'),
        path: AppRoute.manageLandowner,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Thông tin chủ mặt bằng')),
        icon: 'fa-solid fa-house-user',
        path: `${AppRoute.landlordInfo}/${user?.agency?.agencyId}`,
        breadcrumPath: t('Thông tin chủ mặt bằng'),
      },
      {
        type: 'item',
        text: 'Đơn Cho Thuê MB & Mua Hàng',
        icon: 'fa-solid fa-clock-rotate-left',
        path: AppRoute.premiseOrderList,
        breadcrumPath: t('Đơn cho thuê MB & mua hàng'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('landownerReconciliationReport')),
        icon: 'fa-solid fa-file-chart-column',
        path: AppRoute.landlordReport,
        breadcrumPath: t('landownerReconciliationReport'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Rút tiền về tài khoản')),
        icon: 'fa-solid fa-hand-holding-dollar',
        path: AppRoute.withdrawTransaction,
        breadcrumPath: t('Rút tiền về tài khoản'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử giao dịch')),
        icon: 'fa-solid fa-circle-dollar',
        path: AppRoute.transactionHistory,
        breadcrumPath: t('Lịch sử giao dịch'),
      },
      {
        type: 'section',
        text: t('Quản lý trạm sạc'),
        path: AppRoute.manageChargeStations,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationList')),
        icon: 'fa-solid fa-charging-station',
        path: AppRoute.stationList,
        breadcrumPath: t('chargeStationList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargePointList')),
        icon: 'fa-solid fa-transformer-bolt',
        path: AppRoute.pointList,
        breadcrumPath: t('chargePointList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Quản lý mặt bằng')),
        icon: 'fa-solid fa-map-location-dot',
        path: AppRoute.premisesList,
        breadcrumPath: t('Quản lý mặt bằng'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
        icon: 'fa-solid fa-map',
        path: AppRoute.stationsMap,
        breadcrumPath: t('chargeStationMap'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Danh sách hóa đơn tiền điện')),
        icon: 'fa-solid fa-file-invoice-dollar',
        path: AppRoute.energyBillList,
        breadcrumPath: t('Danh sách hóa đơn tiền điện'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Bảo trì/sửa chữa')),
        icon: 'fa-solid fa-screwdriver-wrench',
        path: AppRoute.ticketList,
        breadcrumPath: t('Bảo trì/sửa chữa'),
      },
      {
        type: 'section',
        text: t('ManageChargeTransaction'),
        path: AppRoute.chargeTransactionList,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeTransactionList')),
        icon: 'fas fa-list',
        path: AppRoute.chargeTransactionList,
        breadcrumPath: t('chargeTransactionList'),
      },
      {
        type: 'section',
        text: t('system'),
        path: AppRoute.manageSystem,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('manageStaffs')),
        icon: 'fa-solid fa-user-vneck',
        path: AppRoute.manageStaffs,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('staffList')),
            path: AppRoute.staffList,
            breadcrumPath: t('staffList'),
          },
          {
            text: t('Quản Lý Nhóm Quyền NV'),
            path: AppRoute.staffPermissionList,
            breadcrumPath: t('Quản Lý Nhóm Quyền NV'),
          },
        ],
      },
    ],
    maintainer: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.maintainerDashboard,
        breadcrumPath: t('dashboard'),
      },
      {
        type: 'section',
        text: t('QUẢN LÝ CÔNG VIỆC'),
        path: AppRoute.manageTickets,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Thông tin kỹ thuật viên')),
        icon: 'fa-solid fa-user-helmet-safety',
        path: `${AppRoute.maintainerInfo}/${user?.agency?.agencyId}`,
        breadcrumPath: t('Thông tin kỹ thuật viên'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Bảo trì, sửa chữa')),
        icon: 'fas fa-box-check',
        path: AppRoute.manageTickets,
        subMenuItems: [
          {
            text: Utils.capitalizeFirstLetter(t('Công việc của tôi')),
            path: AppRoute.myTicket,
            breadcrumPath: t('Công việc của tôi'),
          },
          {
            text: Utils.capitalizeFirstLetter(t('Danh sách công việc')),
            path: AppRoute.ticketList,
            breadcrumPath: t('Danh sách công việc'),
          },
        ],
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Báo cáo đối soát kỹ thuật viên')),
        icon: 'fa-solid fa-file-chart-column',
        path: AppRoute.maintainerReport,
        breadcrumPath: t('Báo cáo đối soát kỹ thuật viên'),
      },
      {
        type: 'section',
        text: t('Quản lý trạm sạc'),
        path: AppRoute.manageChargeStations,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationList')),
        icon: 'fa-solid fa-charging-station',
        path: AppRoute.maintainerStationList,
        breadcrumPath: t('chargeStationList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargePointList')),
        icon: 'fa-solid fa-transformer-bolt',
        path: AppRoute.maintainerPointList,
        breadcrumPath: t('chargePointList'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
        icon: 'fa-solid fa-map',
        path: AppRoute.maintainerStationsMap,
        breadcrumPath: t('chargeStationMap'),
      },
    ],
    fleet: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.fleetDashboard,
        breadcrumPath: t('dashboard'),
      },
      {
        type: 'section',
        text: t('QUẢN LÝ DOANH NGHIỆP'),
        path: AppRoute.manageFleets,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Thông tin doanh nghiệp vận tải')),
        icon: 'fa-solid fa-briefcase',
        path: `${AppRoute.fleetInfo}/${user?.agency?.agencyId}`,
        breadcrumPath: t('Thông tin doanh nghiệp vận tải'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Nạp tiền vào ví')),
        icon: 'fa-solid fa-circle-dollar-to-slot',
        path: AppRoute.fleetTopup,
        breadcrumPath: t('Nạp tiền vào ví'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử giao dịch')),
        icon: 'fa-solid fa-circle-dollar',
        path: AppRoute.fleetTransaction,
        breadcrumPath: t('Lịch sử giao dịch'),
      },
      {
        type: 'section',
        text: t('QUẢN LÝ TÀI XẾ'),
        path: AppRoute.manageDrivers,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Danh sách tài xế')),
        icon: 'fa-solid fa-users',
        path: AppRoute.driverList,
        breadcrumPath: t('Danh sách tài xế'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Danh sách xe của tài xế')),
        icon: 'fa-solid fa-cars',
        path: AppRoute.vehicleList,
        breadcrumPath: t('Danh sách xe của tài xế'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử sạc xe của tài xế')),
        icon: 'fa-solid fa-battery-bolt',
        path: AppRoute.chargeTransactionList,
        breadcrumPath: t('Lịch sử sạc xe của tài xế'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử nạp tiền của tài xế')),
        icon: 'fa-solid fa-clock-rotate-left',
        path: AppRoute.customerTopUpHistory,
        breadcrumPath: t('Lịch sử nạp tiền của tài xế'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Báo cáo đối soát tài xế')),
        icon: 'fa-solid fa-file-chart-column',
        path: `${AppRoute.fleetReport}/${user?.agency?.agencyId}/drivers`,
        breadcrumPath: t('Báo cáo đối soát tài xế'),
      },
      {
        type: 'section',
        text: t('Quản lý trạm sạc'),
        path: AppRoute.manageChargeStations,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('chargeStationMap')),
        icon: 'fa-solid fa-map',
        path: AppRoute.fleetStationsMap,
        breadcrumPath: t('chargeStationMap'),
      },
    ],
    voucher_partner: [
      {
        type: 'section',
        text: t('manageGeneralInfo'),
        path: AppRoute.manageGeneralInfo,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('dashboard')),
        icon: 'fa-solid fa-grid-2',
        path: AppRoute.voucherPartnerDashboard,
        breadcrumPath: t('dashboard'),
      },
      {
        type: 'section',
        text: t('QUẢN LÝ ĐỐI TÁC'),
        path: AppRoute.manageVoucherPartner,
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Thông tin đối tác')),
        icon: 'fa-solid fa-briefcase',
        path: `${AppRoute.voucherPartnerInfo}/${user?.agency?.agencyId}`,
        breadcrumPath: t('Thông tin đối tác'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Danh sách xe')),
        icon: 'fa-solid fa-cars',
        path: AppRoute.voucherPartnerVehicle,
        breadcrumPath: t('Danh sách xe'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Lịch sử mua lô voucher')),
        icon: 'fa-solid fa-clock-rotate-left',
        path: AppRoute.voucherBatchList,
        breadcrumPath: t('Lịch sử mua lô voucher'),
      },
      {
        type: 'item',
        text: Utils.capitalizeFirstLetter(t('Danh sách voucher')),
        icon: 'fa-solid fa-map',
        path: AppRoute.voucherList,
        breadcrumPath: t('Danh sách voucher'),
      },
    ],
    default: [],
  };

  const agencyRole =
    user?.role !== AppConstants.userRole.agency
      ? user?.role?.toLowerCase()
      : Array.isArray(agencyRoleList) && agencyRoleList.length > 0
        ? agencyRoleList[0]?.toLowerCase()
        : 'default';
  return MenuItemsList[agencyRole] || MenuItemsList.default;
}

export default getMenuItemsList;
